import {
  forgotPasswordApi,
  resetPasswordApi,
  verifyEmailAccountApi,
  compresetPasswordApi,
} from "helpers/API/AuthApi"
import { call, put, takeEvery } from "redux-saga/effects"
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  userForgetPasswordError,
  userForgetPasswordSuccess,
  userResetPasswordSuccess,
  userResetPasswordError,
  EmailVerifySuccess,
  EmailVerifyError,
  resetUserSuccesss,
  resetUserFails,
} from "./actions"
// Login Redux States
import {
  FORGET_PASSWORD,
  POST_RESET_USER,
  RESET_PASSWORD,
  VERIFY_EMAIL_ACCOUNT,
} from "./actionTypes"
import { togglePageLoader } from "store/actions"

const fireBaseBackend = getFirebaseBackend()

//If user is send successfully send mail link then dispatch redux action's are directly from here.
// function* forgetUser({ payload: { user, history } }) {
//   try {
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const response = yield call(fireBaseBackend.forgetPassword, user.email)
//       if (response) {
//         yield put(
//           userForgetPasswordSuccess(
//             "Reset link are sended to your mailbox, check there first"
//           )
//         )
//       }
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//       const response = yield call(postJwtForgetPwd, "/jwt-forget-pwd", {
//         email: user.email,
//       })
//       if (response) {
//         yield put(
//           userForgetPasswordSuccess(
//             "Reset link are sended to your mailbox, check there first"
//           )
//         )
//       }
//     } else {
//       const response = yield call(postFakeForgetPwd, "/fake-forget-pwd", {
//         email: user.email,
//       })
//       if (response) {
//         yield put(
//           userForgetPasswordSuccess(
//             "Reset link are sended to your mailbox, check there first"
//           )
//         )
//       }
//     }
//   } catch (error) {
//     yield put(userForgetPasswordError(error))
//   }
// }

function* forgetUser({ payload: { user } }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(forgotPasswordApi, user)
    yield put(togglePageLoader(false))
    if (response.status
      === "Success") {
      yield put(userForgetPasswordSuccess(response))
    }
    if (response.status
      === "Failed") {
      yield put(userForgetPasswordError(response))
    }
  } catch (error) {
    yield put(togglePageLoader(false))
  }
}

function* resetPasswordAction({ payload: { user, history } }) {

  try {
    yield put(togglePageLoader(true))
    const response = yield call(resetPasswordApi, user);  
    yield put(togglePageLoader(false))
    if (response.status === "Success") {        
      yield put(userResetPasswordSuccess(response))
      history.push("/login")
    }
     if (response.status === "Failed") {
      yield put(userResetPasswordError(response))
    }
     
  } catch (error) {
    yield put(togglePageLoader(false))
    // console.log('error',response)    
  }
}

function* verifyEmailAccount({ payload: { data } }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(verifyEmailAccountApi,data);
    yield put(togglePageLoader(false))
    console.log(response,'response')
    if (response.status
      === "Success") {
        console.log('enter')
        yield put(EmailVerifySuccess(response));
    }
    if (response.status
      === "Failed") {
        yield put(EmailVerifyError(response));
    }
   
  } catch (error) {
    yield put(togglePageLoader(false))   
  }
}
function* onResetUser({ payload: { user, history } }) {

  try {
    const response = yield call(compresetPasswordApi, user)
    console.log(response, "data")
    if (response.status === "Success") {
      yield put(resetUserSuccesss({ response }))
      history.push("/login")
    }
    if (response.status === "Failure") {
      yield put(resetUserFails(response))
    }
    if (response.status === "Failed") {
      yield put(resetUserFails(response))
    }
  } catch (error) {
    yield put(resetUserFails(error))
  }
}
function* forgetPasswordSaga() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
  yield takeEvery(RESET_PASSWORD, resetPasswordAction)
  yield takeEvery(VERIFY_EMAIL_ACCOUNT, verifyEmailAccount)
  // reset password
  yield takeEvery(POST_RESET_USER, onResetUser)
}

// resetPasswordApi
export default forgetPasswordSaga
